import type { OrderSummary } from '@/infrastructure/OMSClient';
import { ShippingProviderType } from '@/infrastructure/OMSClient';

type ShipmentDisplayOrder = Pick<OrderSummary, 'parxlData' | 'shippingData'>;

export const shouldShowLegacyDeleoShipment = (order: ShipmentDisplayOrder): boolean =>
  !order.parxlData && (!order.shippingData?.provider || order.shippingData.provider === ShippingProviderType.DELEO);

export const shouldShowPdfLabelPrint = (provider: ShippingProviderType | null): boolean =>
  provider !== ShippingProviderType.FEDEX;
